// Module
var code = "<div class=\"selected-circle\"> <div class=\"half-circle-2-color\"> <div class=\"circle-content-selected\"><span class=\"circle-number\">1</span></div> </div> </div> ";
// Exports
module.exports = code;